module.exports = __webpack_public_path__ + "img/15.2.TN.7eaa2a63.png";